// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const LeadScoringPage = lazy(() => import('./pages/LeadScoringPage'));
const TerritoriesPage = lazy(() => import('./pages/TerritoriesPage'));
const AccountHierarchiesPage = lazy(() => import('./pages/AccountHierarchiesPage'));
const DealCollaborationPage = lazy(() => import('./pages/DealCollaborationPage'));
const DealAlertsPage = lazy(() => import('./pages/DealAlertsPage'));
const EngagementLogPage = lazy(() => import('./pages/EngagementLogPage'));
const DealAnalyticsPage = lazy(() => import('./pages/DealAnalyticsPage'));

export const AdvancedRoutes: RouteObject = {
  path: 'advanced',
  element: <ModuleGuard moduleId="sales.advanced" />,
  children: [
    { path: 'lead-scoring', element: <LeadScoringPage />, handle: { crumb: 'Lead Scoring' } },
    { path: 'territories', element: <TerritoriesPage />, handle: { crumb: 'Territories' } },
    { path: 'account-hierarchies', element: <AccountHierarchiesPage />, handle: { crumb: 'Account Hierarchies' } },
    { path: 'deal-collaboration', element: <DealCollaborationPage />, handle: { crumb: 'Deal Collaboration' } },
    { path: 'deal-alerts', element: <DealAlertsPage />, handle: { crumb: 'Deal Alerts' } },
    { path: 'engagement-log', element: <EngagementLogPage />, handle: { crumb: 'Engagement Log' } },
    { path: 'deal-analytics', element: <DealAnalyticsPage />, handle: { crumb: 'Deal Analytics' } },
  ],
};
